import { Minus, Plus, ShoppingCartIcon, Trash2 } from 'lucide-react'
import { Button } from '../../../components/ui/button'
import { ScrollArea } from '../../../components/ui/scroll-area'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../components/ui/table'
import { formatToBRL } from '../../../utils/formatCurrency'

interface ShoppingCartProps {
  closeShoppingCart: () => void
  updateCart: (data: any) => void
  calculateTotal: (cart: any) => any
  cart: {
    produtos: any[]
    planos: any[]
    servicos: any[]
  }
}

export function ShoppingCart({ closeShoppingCart, cart, updateCart, calculateTotal }: ShoppingCartProps) {
  const minusProduct = (product: any) => {
    const productsUpdated = cart.produtos.map((item: any) => {
      if (item.id == product.id) {
        if (item.quantidade <= 1) return item
        item.quantidade -= 1
      }
      return item
    })

    updateCart({
      ...cart,
      produtos: productsUpdated
    })
  }

  const plusProduct = (product: any) => {
    const productsUpdated = cart.produtos.map((item: any) => {
      if (item.id == product.id) {
        item.quantidade += 1
      }
      return item
    })

    updateCart({
      ...cart,
      produtos: productsUpdated
    })
  }

  const deleteFromCart = (from: 'planos' | 'produtos' | 'servicos', item: any) => {
    const data = {
      ...cart
    }

    const itemUpdated = (data[from] = data[from].filter((cartItem: any) => cartItem.id != item.id))
    data[from] = itemUpdated

    updateCart(data)
  }

  return (
    <div className="fixed w-full h-full left-0 top-0 bg-black/50 flex items-center justify-center z-10">
      <div className="bg-white shadow-md rounded-md w-3/4 h-3/4 p-4 flex gap-4 flex-col">
        <h3 className="text-2xl font-bold flex gap-2 items-center">
          <ShoppingCartIcon className="font-bold" /> Cesto de compras
        </h3>
        <ScrollArea className="h-4/5">
          <Table className="">
            <TableHeader>
              <TableRow>
                <TableHead className="">Nome</TableHead>
                <TableHead>Tipo</TableHead>
                <TableHead>Valor</TableHead>
                <TableHead>Quantidade</TableHead>
                <TableHead className="text-center">Ações</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {cart.planos.map((plan: any) => (
                <TableRow key={plan.id}>
                  <TableCell className="font-medium">{plan.label}</TableCell>
                  <TableCell>Plano</TableCell>
                  <TableCell>{formatToBRL(plan.valor)}</TableCell>
                  <TableCell>1</TableCell>
                  <TableCell className="">
                    <div className="flex items-center justify-center">
                      <Trash2 className="rounded-md shadow-md bg-red-400 cursor-pointer hover:bg-red-500 p-1" onClick={() => deleteFromCart('planos', plan)} />
                    </div>
                  </TableCell>
                </TableRow>
              ))}

              {cart.servicos.map((service: any) => (
                <TableRow key={service.id}>
                  <TableCell className="font-medium">{service.label}</TableCell>
                  <TableCell>Serviço</TableCell>
                  <TableCell>{formatToBRL(service.valor)}</TableCell>
                  <TableCell>1</TableCell>
                  <TableCell className="text-center">
                    <div className="flex items-center justify-center">
                      <Trash2 className="rounded-md shadow-md bg-red-400 cursor-pointer hover:bg-red-500 p-1" onClick={() => deleteFromCart('servicos', service)} />
                    </div>
                  </TableCell>
                </TableRow>
              ))}

              {cart.produtos.map((product: any) => (
                <TableRow key={product.id}>
                  <TableCell className="font-medium">{product.label}</TableCell>
                  <TableCell>Produto</TableCell>
                  <TableCell>{formatToBRL(product.valor)}</TableCell>
                  <TableCell>{product.quantidade}</TableCell>
                  <TableCell className="">
                    <div className="flex items-center justify-center gap-2">
                      <Minus className="rounded-md shadow-md bg-acelerafit-green-400 cursor-pointer hover:bg-cashfit-green-200 p-1" onClick={() => minusProduct(product)} />
                      <Plus className="rounded-md shadow-md bg-acelerafit-green-400 cursor-pointer hover:bg-cashfit-green-200 p-1" onClick={() => plusProduct(product)} />
                      <Trash2 className="rounded-md shadow-md bg-red-400 cursor-pointer hover:bg-red-500 p-1" onClick={() => deleteFromCart('produtos', product)} />
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </ScrollArea>

        <div className="container flex items-center justify-between">
          <span className="font-bold">Total: {formatToBRL(calculateTotal(cart))}</span>
          <Button onClick={closeShoppingCart}>Fechar</Button>
        </div>
      </div>
    </div>
  )
}
